export default import.meta.ROLLDOWN_FILE_URL_rxbqBRHNuSGzM2uw8EEZ8g